import './assets/main.scss'

import '@stripe/stripe-js'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './app.vue'

import type { RuntimeConfiguration } from '@/store/configuration/runtime-configuration'

const stripeScript = document.createElement('script')
stripeScript.setAttribute('src', 'https://js.stripe.com/v3')
document.body.appendChild(stripeScript)

function uTerm(selector: string, options: RuntimeConfiguration): void {
    window.runtimeConfiguration = options
    const app = createApp(App)

    if (options.recaptchaV3SiteKey) {
        app.use(VueReCaptcha, { siteKey: options.recaptchaV3SiteKey ?? '', loaderOptions: {} })
    }

    const maxRetries = 10
    let retries = 0
    const launch = () => {
        if (retries >= maxRetries) {
            return
        }
        retries++
        try {
            app.use(createPinia())
            app.mount(selector)
        } catch (e) {
            setTimeout(launch, 200)
        }
    }
    launch()
}

window.uTerm = uTerm
